// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R

import React, { useState } from 'react';
import { mergeClasses, normalizeNumber } from 'util/commons';
import { TraceDataInfo } from 'types/purchase';
import styles from './PurchaseTraceBoard.module.scss';
import ProcessTag from './ProcessTag';
import { OperatorType } from 'util/Enums';
import { useTranslation } from 'react-i18next';
import PurchaseTraceDetailModal from '../PurchaseTraceDetailModal';
import {
  getTraceDetailCsv,
  getTraceDetailCsvFilename,
} from 'util/purchaseBoardUtils';
import Csv from 'util/csv';

type Props = {
  stageId: number | null;
  stageIndex: number;
  info: TraceDataInfo;
  stage: OperatorType;
  isSelected: boolean;
  isHighlighted: boolean;
  isDimmed: boolean;
  onClick: () => void;
};

/** Renders a single site card. Accept full TraceDataInfo so caller can customize content. */
const TraceBoardCard: React.FC<Props> = ({
  stageId,
  stageIndex,
  info,
  stage,
  isSelected,
  isHighlighted,
  isDimmed,
  onClick,
}) => {
  const { t } = useTranslation();
  const [showDetail, setShowDetail] = useState(false);

  const handleDownloadCsv = () => {
    const { headers, data } = getTraceDetailCsv({
      t,
      detail: {
        id: stageId,
        stageIndex,
        stage,
        sites: [info],
      },
    });

    new Csv({
      headers,
      data: data.flat(),
    }).downLoadCsv({
      filename: getTraceDetailCsvFilename({
        id: info.siteName,
        stage,
        stageIndex,
        t,
      }),
    });
  };

  return (
    <div
      data-card
      className={mergeClasses(styles.card, {
        [styles.cardSelected]: isSelected,
        [styles.cardHighlighted]: isHighlighted && !isSelected,
        [styles.cardDimmed]: isDimmed,
      })}
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
    >
      <div className={styles.cardHeader}>
        <ProcessTag stage={stage} />

        <p>
          {normalizeNumber({
            value: info.totalWeight,
          })}
          kg
        </p>
      </div>

      <p className={styles.cardSiteName}>{info.siteName}</p>

      <div className={styles.cardHeader}>
        <p className={styles.cardDataCount}>
          {normalizeNumber({ value: info.data.length })} IDs
        </p>

        <button
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setShowDetail(true);
          }}
          className={styles.detailButton}
        >
          {t('common.detail')}
        </button>
      </div>

      {showDetail && (
        <PurchaseTraceDetailModal
          stage={stage}
          stageIndex={stageIndex}
          onClose={() => setShowDetail(false)}
          info={info}
          onDownload={handleDownloadCsv}
        />
      )}
    </div>
  );
};

export default React.memo(TraceBoardCard);
